<template>
  <div v-if="listMedicines" class="inner-graph-content">
    <Spinner :isLoading="isLoading" />
    <div class="medication-status">
      <div class="content-area">
        <h3>{{ $t('medication_status') }}</h3>
        <dl class="clearfix">
          <dt><span class="date-ttl">{{ $t('prescription_start_date') }}</span></dt>
          <dd><span class="med-ttl">{{ $t('prescription_drugs')}}*</span></dd>
        </dl>
        <dl class="clearfix" v-for="item in medicines" :key="item.id">
          <dt><span class="datePrescription">{{ item.date }}</span></dt>
          <dd>{{ item.name }}</dd>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex"
import Spinner from "@/js/components/Spinner"
import moment from "moment"
import i18n from '@/lang/i18n'

export default {
  data() {
    return {
      isLoading: true,
    }
  },
  props: {
    activePage: {
      type: String,
      required: true
    }
  },
  components: {
    Spinner
  },
  computed: {
    ...mapState({
      listMedicines: state => state.medicine.medicines,
      otpAccessToken: state => state.otp.otpAccessToken
    }),
    medicines() {

      const medicineInfo = this.listMedicines.filter((item) => item.medicine_record.length > 0)
      return medicineInfo.map((item, index) => {
        const medicines = item.medicine_record.map((record) => {
          return record.medicine_name + (( !record.is_external && record.total_ingredient != 0 ) ? (record.multiple_ingredient_amount === true ? '' : '【'+ (record.total_ingredient_amount > 0 ? (record.total_ingredient_amount + record.ingredient_unit) : i18n.t('application_not_entered')) +'】') : '')
        })
        return {
          date: moment(item.medicine_start_date).format('YYYY/MM/DD'),
          name: medicines.reduce((a,b) => a + '、' + b)
        }
      })
    }
  },
  watch: {
    async activePage() {
      if (this.activePage === 'medication-status') {
        await this.getData()
        this.isLoading = false
      }
    }
  },
  methods: {
    async getData() {
      const today = new Date()
      const tomorrow = new Date()
      tomorrow.setDate(today.getDate() + 1)
      if (!this.$route.params.childId) {
        let params = {
          one_time_access_key: this.otpAccessToken,
          from_date: moment(today).format('YYYY/MM/DD'),
          to_date: moment(tomorrow).format('YYYY/MM/DD')
        }
        await this.$store.dispatch("medicine/getMedicines", { params: params })
        .then( res => {})
        .catch((error) => {console.log(error)})
      } else {
        let params = {
          childId: this.$route.params.childId,
          from_date:  moment(today).format('YYYY/MM/DD'),
          to_date: moment(tomorrow).format('YYYY/MM/DD')
        }
        await this.$store.dispatch("medicine/getMedicines", { params: params })
        .then( res => {})
        .catch((error) => {console.log(error)})
      }
    },
  }
}
</script>
<style lang="css">
  .datePrescription {
    font-size: 0.9rem;
    font-weight: normal;
  }
</style>